import React, { createContext, useContext, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const { mockData, updateMockData } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  React.useEffect(() => {
    if (mockData?.notificaciones) {
      const count = mockData.notificaciones.filter(n => !n.leida).length;
      setUnreadCount(count);
    }
  }, [mockData]);

  const addNotification = useCallback((tipo, titulo, mensaje, entidad = null, entidadId = null) => {
    const newNotification = {
      id: `${Date.now()}-${Math.random()}`,
      tipo,
      titulo,
      mensaje,
      timestamp: new Date().toISOString(),
      leida: false,
      entidad,
      entidadId
    };

    const updatedNotifications = [newNotification, ...(mockData?.notificaciones || [])];
    updateMockData({ notificaciones: updatedNotifications });
    setUnreadCount(prev => prev + 1);
  }, [mockData, updateMockData]);

  const markAsRead = useCallback((notificationId) => {
    const updatedNotifications = mockData.notificaciones.map(n =>
      n.id === notificationId ? { ...n, leida: true } : n
    );
    updateMockData({ notificaciones: updatedNotifications });
    setUnreadCount(prev => Math.max(0, prev - 1));
  }, [mockData, updateMockData]);

  const markAllAsRead = useCallback(() => {
    const updatedNotifications = mockData.notificaciones.map(n => ({ ...n, leida: true }));
    updateMockData({ notificaciones: updatedNotifications });
    setUnreadCount(0);
  }, [mockData, updateMockData]);

  const value = {
    notifications: mockData?.notificaciones || [],
    unreadCount,
    addNotification,
    markAsRead,
    markAllAsRead
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications debe usarse dentro de NotificationProvider');
  }
  return context;
};
